// ============================================================================
// DATA SOURCE CONFIGURATION
// ============================================================================

export const DATA_CONFIG = {
  // Google Sheets configuration
  // Structure: Each asset has its own sheet within the same spreadsheet
  googleSheets: {
    spreadsheetId: '1vvBifuvBrppk8RN3z-8qO2348BVGORmsEsnOCJ6vtoA',
    useApiAuth: true, // Using API authentication
    apiKey: process.env.REACT_APP_GOOGLE_SHEETS_API_KEY || '', // Set via environment variable

    // Sheet names for each asset
    sheetNames: {
      bitcoin: 'Bitcoin',
      ethereum: 'Ethereum',
      sui: 'Sui',
      solana: 'Solana',
      bnb: 'BNB',
      avax: 'Avax',
      doge: 'Doge',
      aptos: 'Aptos',
      cardano: 'Cardano',
      trx: 'Trx',
      zcash: 'Zcash',
      walrus: 'Walrus',
      coin98: 'Coin98'
    },

    // Column structure (assuming same structure across all sheets)
    columns: {
      date: 'Date',   // Column name for date
      price: 'Price'  // Column name for price
    }
  },

  // Asset-specific API configurations for recent 30-day data
  apis: {
    bitcoin: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/bitcoin/market_chart',
      enabled: true
    },
    ethereum: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/ethereum/market_chart',
      enabled: true
    },
    sui: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/sui/market_chart',
      enabled: true
    },
    solana: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/solana/market_chart',
      enabled: true
    },
    bnb: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/binancecoin/market_chart',
      enabled: true
    },
    avax: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/avalanche-2/market_chart',
      enabled: true
    },
    doge: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/dogecoin/market_chart',
      enabled: true
    },
    aptos: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/aptos/market_chart',
      enabled: true
    },
    cardano: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/cardano/market_chart',
      enabled: true
    },
    trx: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/tron/market_chart',
      enabled: true
    },
    zcash: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/zcash/market_chart',
      enabled: true
    },
    walrus: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/walrus-2/market_chart',
      enabled: true
    },
    coin98: {
      provider: 'coingecko',
      baseUrl: 'https://api.coingecko.com/api/v3',
      endpoint: '/coins/coin98/market_chart',
      enabled: true
    }
  },

  // Cache configuration
  cache: {
    enabled: true,
    ttl: 3600000, // 1 hour in milliseconds
    storageKey: 'what-if-invested-cache'
  },

  // Data cutoff: how many days back to use API vs Google Sheets
  recentDataDays: 30
};
